import { Box, Button, Stack, StackProps } from "@mui/material";
import React from "react";
import { WizardSchemaType } from "./index";

interface StepNavigatorProps extends StackProps {
	started: boolean;
	isCompletedStep: boolean;
	isLastStep: boolean;
	disabledBack?: boolean;
	onNext: () => void;
	onBack: () => void;
}

const StepNavigator: React.FC<StepNavigatorProps> = (props) => {
	const {
		started,
		isCompletedStep,
		isLastStep,
		disabledBack = false,
		onNext,
		onBack,
		...stackProps
	} = props;

	return (
		<Stack direction="row" spacing={3} {...stackProps}>
			<Box flex={1}>
				{!isCompletedStep && (
					<Box display="flex" mt={2} justifyContent="space-between">
						{started && (
							<Button
								variant="outlined"
								size="large"
								onClick={onBack}
								disabled={disabledBack}
								sx={{
									backgroundColor: "white",
									width: (theme) => theme.spacing(17.5),
								}}
							>
								Quay lại
							</Button>
						)}

						{started && !isLastStep && (
							<Button
								variant="contained"
								color="primary"
								size="large"
								onClick={onNext}
								sx={{
									width: (theme) => theme.spacing(17.5),
								}}
							>
								Tiếp tục
							</Button>
						)}
					</Box>
				)}
			</Box>
		</Stack>
	);
};

export default StepNavigator;
